(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/competition-context/assets/javascripts/competition-context.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/competition-context/assets/javascripts/competition-context.js');
"use strict";


const _React = React,
  createContext = _React.createContext;
const CompetitionContext = createContext({
  competitionId: undefined,
  useDraws: _ref => {
    let drawNumbers = _ref.drawNumbers,
      productId = _ref.productId;
    throw new Error('Missing implementation');
  }
});
setGlobal('svs.components.marketplaceCompetition.competitionContext.CompetitionContext', CompetitionContext);

 })(window);